import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { ProPlanCatalog } from '@/shared/domain'
import type { LoadProPlanCatalog } from '@/modules/auth/use-cases'

export class EdgeLoadProPlanCatalogRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadProPlanCatalog = async () => {
    const request: HttpRequest<never> = { url: '/pro-billing/plans' }
    return this.httpClient.get<ProPlanCatalog>(request)
  }
}
